export enum FinanceApplicationCodes {
    New = 1,
    DataValidated = 2,
    DataValidationError = 3,
    AwaitingDecision = 4,
    AwaitingSigning = 6,
    Signed = 7,
    Completed = 8,
    Declined = 9
}